import React from "react";
import { foodLabelDetails } from "../../helpers/foodLabelUtils";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";

const FoodLabelListMobile = () => {
  const { loading } = useSelector((state: RootState) => state.loader);
  const { items } = useSelector((state: RootState) => state.cart);
  if (loading) return null;
  return (
    <div
      className={`food-label-list d-flex flex-row ${
        items.length > 0 ? "cart-active" : ""
      }`}
    >
      {foodLabelDetails.map((label) => (
        <div
          key={label.id}
          className="food-label d-flex flex-row align-items-center"
        >
          <img src={label.icon} alt={label.label} className="food-label-icon" />
          <span className="food-label-text">{label.label}</span>
        </div>
      ))}
    </div>
  );
};

export default FoodLabelListMobile;
